module.exports = __webpack_public_path__ + "static/media/arrow-left.ef31cea4.png";